"use strict";

require("core-js/modules/es.object.assign.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FAETextField = void 0;

require("core-js/modules/web.dom-collections.iterator.js");

var _react = _interopRequireWildcard(require("react"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _FAEContainer = require("../FAEContainer/FAEContainer");

var _FAEText = require("../FAEText/FAEText");

var _FAEShadowBox = require("../FAEShadowBox/FAEShadowBox");

require("./FAETextField.scss");

const _excluded = ["justify", "align", "className", "label", "shadowBoxProps", "primary", "type", "placeholder", "value", "getValue", "error", "errorMessage", "isRequired", "textFieldClass"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const FAETextField = _ref => {
  let {
    justify,
    align,
    className = "",
    label,
    shadowBoxProps,
    primary,
    type,
    placeholder,
    value = "",
    getValue = () => {},
    error = () => {},
    errorMessage,
    isRequired = false,
    textFieldClass
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  const [initialValue, setInitialValue] = (0, _react.useState)("");

  const handleChange = e => {
    setInitialValue(e.target.value);
    getValue(e.target.value);
  };

  (0, _react.useEffect)(() => {
    setInitialValue(value);
  }, [value]);
  return /*#__PURE__*/_react.default.createElement(_FAEContainer.FAEContainer, {
    justify: justify,
    align: align
  }, primary ? /*#__PURE__*/_react.default.createElement(_FAEShadowBox.FAEShadowBox, _extends({}, shadowBoxProps, {
    padding: true
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--text-field-container ".concat(className)
  }, /*#__PURE__*/_react.default.createElement(_FAEText.FAEText, {
    important: isRequired && true,
    tertiary: true
  }, label), /*#__PURE__*/_react.default.createElement(_TextField.default, _extends({
    error: error(initialValue),
    helperText: error(initialValue) && errorMessage,
    value: initialValue,
    onChange: handleChange,
    placeholder: placeholder,
    type: type,
    className: textFieldClass
  }, rest)))) : /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--text-field-container ".concat(className)
  }, /*#__PURE__*/_react.default.createElement(_FAEText.FAEText, {
    important: isRequired && true,
    tertiary: true
  }, label), /*#__PURE__*/_react.default.createElement(_TextField.default, _extends({
    error: error(initialValue),
    helperText: error(initialValue) && errorMessage,
    value: initialValue,
    onChange: handleChange,
    placeholder: placeholder,
    type: type,
    variant: "outlined",
    className: textFieldClass
  }, rest))));
};

exports.FAETextField = FAETextField;